import React from 'react';
import PropTypes from 'prop-types';
import SecureImg from '../../assets/secure.png';
import {Paragraph4} from 'baseui/typography';

import {useTranslation} from 'react-i18next';

const Footer = props => {
  const {t, i18n} = useTranslation();
  return (
    <React.Fragment>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          marginTop: '30px',
        }}>
        <div
          style={{
            display: 'flex',
            maxWidth: '500px',
            width: '80%',
          }}>
          <img
            src={SecureImg}
            style={{maxWidth: '100%', height: 'auto', objectFit: 'contain'}}
          />
        </div>
      </div>
      <div
        style={{textAlign: 'center', marginTop: '30px', marginBottom: '20px'}}>
        <Paragraph4 color="#777" width="350px">
          {t('third_party')}
        </Paragraph4>
        <Paragraph4 color="#777">
          2020 © Global Switch 24 Ltd. {t('rights')}.
        </Paragraph4>
      </div>
    </React.Fragment>
  );
};

export default Footer;
